import React from 'react';
import { CROWN_SRC } from '../assets';

interface WinnerCrownProps {
   className?: string;
}

export function WinnerCrown({ className = '' }: WinnerCrownProps) {
   return (
      <img
         src={CROWN_SRC}
         alt=""
         className={`swamp-crown ${className}`.trim()}
      />
   );
}
